import {FC, useState} from 'react';
import {useProposalsReceiptsGroups} from '../../../providers/ProposalsCovenantsTable/ProposalsReceiptsGroupsProvider';
import moment from 'moment';
import {usePaginate} from '../../../providers/PaginateProvider';
import SkeletonTable from '../../../components/SkeletonTable/SkeletonTable';
import AppPagination from '../../../components/AppPagination/AppPagination';
import './ProposalsReceiptGroups.scss';
import PainelMasterPage from '../../../components/PainelMasterPage/PainelMasterPage';
import PageBase from '../../../components/PageBase/PageBase';
import ModalProposalReceiptGroupsEdit
    from "../../../components/ProposalsTrack/ModalProposalReceiptGroupsEdit/ModalProposalReceiptGroupsEdit";
import {ReceiptGroupModel} from "../../../models/ProposalsTrack/ReceiptGroupModel";
import {ProposalSaleOriginModel} from "../../../models/ProposalsTrack/ProposalSaleOriginModel";
import Swal from "sweetalert2";
import {toast} from "react-toastify";
import ButtonEdit from "../../../components/ButtonEdit/ButtonEdit";
import ButtonDelete from "../../../components/ButtonDelete/ButtonDelete";

interface ProposalsReceiptGroupsProps {
}

const ProposalsReceiptGroups: FC<ProposalsReceiptGroupsProps> = () => {
    const [showModalFilter, setShowModalFilter] = useState<boolean>(false);
    const [showModalInsert, setShowModalInsert] = useState<boolean>(false);
    const [itemEdit, setItemEdit] = useState<ReceiptGroupModel | null>(null);

    const {
        params,
        setParams,
        proposalsReceiptsGroups,
        isLoading,
        handleInative,
        handleList
    } = useProposalsReceiptsGroups();
    const {pagesPaginate, handlePaginate} = usePaginate();


    const handleInativeAlert = (item: ReceiptGroupModel) => {
        Swal.fire({
            title: "Atenção!",
            html: `Deseja realmente inativar a origem ${item.name}`,
            icon: "warning",
            confirmButtonText: "Sim",
            cancelButtonText: "Não",
            showConfirmButton: true,
            showCancelButton: true,
        }).then((value) => {
            if (value.isConfirmed) {
                deleteItem(item)
            }

        })
    }

    const deleteItem = async (item: ReceiptGroupModel) => {
        const res = await handleInative(item?.id ?? null);
        if (!res) {
            handleList();
            toast.success(`${item.name} inativado com sucesso!`)
            return;
        }

        toast.error(res)

    }


    const renderList = () => {
        if (proposalsReceiptsGroups?.length > 0) {
            return (
                <>
                    {proposalsReceiptsGroups?.map((x: any) => (
                        <tr key={x.id}>
                            <td className="text-sm text-center">{x.id}</td>
                            <td className="text-sm text-wrap" style={{width: '20%'}}>{x.name}</td>
                            <td className="text-center text-sm">
                <span className={`badge ${!!x.deleted_at ? 'badge-danger' : 'badge-success'}`}>
                  {!!x.deleted_at ? 'Inativa' : 'Ativa'}
                </span>
                            </td>
                            <td className="text-center text-sm">{moment(x.created_at).format('DD/MM/YYYY HH:mm:ss')}</td>
                            <td className='text-center text-sm'>
                                <td className='text-center text-sm'>
                                 <span className='d-flex gap-2'>
                                <ButtonEdit
                                    tooltipText="Editar"
                                    onClick={() => {
                                        setItemEdit(x);
                                        setShowModalInsert(true);
                                    }}
                                />
                                <ButtonDelete
                                    onClick={() => handleInativeAlert(x)}
                                    tooltipText="Inativar"/>
                                 </span>
                                </td>
                            </td>
                        </tr>
                    ))}
                </>
            );
        } else {
            return (<tr className='text-sm text-center'>
                <td colSpan={5}>Não há registros</td>
            </tr>);
        }
    }

    const renderContent = () => {
        return (
            <div className="table-responsive p-0">
                {isLoading ? (
                    <SkeletonTable columns={5}/>
                ) : (
                    <table className="table table-flush">
                        <thead className="thead-light">
                        <tr>
                            <th className="text-center" scope="col">#ID</th>
                            <th scope="col">NOME</th>
                            <th scope="col" className="text-center">STATUS</th>
                            <th scope="col" className="text-center">DATA DE CADASTRO</th>
                            <th className="text-center" scope="col"></th>
                        </tr>
                        </thead>
                        <tbody>
                        {renderList()}
                        </tbody>
                    </table>
                )}

                {(pagesPaginate) && (
                    <div>
                        <nav aria-label="...">
                            <AppPagination
                                pages={pagesPaginate}
                                handlePaginate={handlePaginate}
                                params={params}
                                setParams={setParams}
                            />
                        </nav>
                    </div>
                )}
            </div>
        )
    }

    return (
        <PainelMasterPage
            title='Grupos de Recebimentos'
            icon='fas fa-comments-dollar'
        >
            <div className="ProposalsReceiptGroups" data-testid="ProposalsReceiptGroups">
                <PageBase
                    content={renderContent()}
                    title={'Grupos de Recebimentos'}
                    subtitle={'Listagem de grupos de recebimentos'}
                    hasFilter={false}
                    textButtonAdd='+ Novo Grupo'
                    handleAdd={() => setShowModalInsert(true)}
                    handleFilter={() => setShowModalFilter(true)}
                />
            </div>
            <ModalProposalReceiptGroupsEdit
                show={showModalInsert}
                item={itemEdit}
                onClose={() => {
                    setItemEdit(null);
                    setShowModalInsert(!showModalInsert)
                }}/>
        </PainelMasterPage>
    );
}

export default ProposalsReceiptGroups;
